// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__JJpPN","head":"Modal_head__wOuWF","title":"Modal_title__zLjJ5","close":"Modal_close__-cVsw","content":"Modal_content__zUlUH"};